module.exports = __webpack_public_path__ + "img/about_1.d5318af9.jpg";